import React from 'react'
import InlineError from './InlineError'
import Loading from './Loading'
import RetryError from './RetryError'

export default function ListContainer({
    loading,
    error,
    onRetry,
    header, // 상단 조작부 (검색/필터/버튼)
    table,  // 표 본문(JSX)
    footer, // 페이지네이션 등 하단부
    emptyText = '표시할 항목이 없습니다',
}) {
    if (loading) return <Loading />
    if (error) return onRetry ? <RetryError message={error} onRetry={onRetry} /> : <InlineError message={error} />
    return (
        <div className="rounded-lg border overflow-x-auto">
            {header}
            {table && (
                <div>
                    {table}
                </div>
            )}
            {!table && (
                <div className="p-4 text-sm text-slate-500">{emptyText}</div>
            )}
            {footer}
        </div>
    )
}
